import {useEffect, useRef} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {TextareaField} from "@pg-design/rhf-components-module";
import {useUserDevice} from "@pg-mono/user-device";

import {hitAiAssistantChat} from "../../tracking/semantic_search_gtm_events";
import {SemanticSearchFormValues} from "../../types/SemanticSearchFormValues";
import {SemanticSearchDisclaimer} from "./SemanticSearchDisclaimer";

const semanticSearchFormSchema = Yup.object().shape({
    userQuery: Yup.string().required("Prosimy wpisać zapytanie")
});

interface IProps {
    handleSubmit: (data: SemanticSearchFormValues) => void;
    disabled: boolean;
    hasConversation: boolean;
    hasStickySidebar: boolean;
}

export function SemanticSearchQueryForm(props: IProps) {
    const {handleSubmit, disabled, hasConversation, hasStickySidebar} = props;

    const {isMobile} = useUserDevice();

    const formProps = useForm<SemanticSearchFormValues>({
        defaultValues: {
            userQuery: ""
        },
        resolver: yupResolver(semanticSearchFormSchema)
    });
    const userQuery = useWatch({control: formProps.control, name: "userQuery"});
    const wasFilledRef = useRef(false);

    useEffect(() => {
        const isFilled = userQuery.length > 0;

        if (isFilled && !wasFilledRef.current) {
            hitAiAssistantChat("fill");
        }

        wasFilledRef.current = isFilled;
    }, [userQuery]);

    const onSubmit = (data: {userQuery: string}) => {
        if (disabled || !data.userQuery.trim()) return;

        hitAiAssistantChat("submit");
        handleSubmit(data);
        formProps.reset();
    };

    const numberOfRows = hasConversation ? 1 : isMobile || hasStickySidebar ? 3 : 2;
    const placeholder = hasConversation
        ? "O co chcesz zapytać?"
        : hasStickySidebar
          ? "Szukam mieszkania 2 pokojowego, do 60 m2, z balkonem, na osiedlu z placem zabaw."
          : "Szukam mieszkania 2 pokojowego, do 60 m2, z balkonem, na Żoliborzu, na osiedlu z placem zabaw.";

    return (
        <div className={formContainer}>
            <FormProvider {...formProps}>
                <form onSubmit={formProps.handleSubmit(onSubmit)} className={formStyle}>
                    <TextareaField
                        name="userQuery"
                        rows={numberOfRows}
                        hideErrorMessage
                        onClick={() => hitAiAssistantChat("click")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                formProps.handleSubmit(onSubmit)();
                            }
                        }}
                        placeholder={placeholder}
                        inputClassName={textArea}
                        inputWrapperClassName={textAreaWrapper}
                        inputWrapperInnerClassName={textAreaWrapperInner}
                        inputContentSlot={
                            <div className={buttonWrap}>
                                <Button variant="filled_primary" type="submit" className={submitButton} disabled={disabled}>
                                    <ChevronRightIcon size="2.4" wrapperSize="4.4" wrapperColor="transparent" wrapperType="square" />
                                </Button>
                            </div>
                        }
                    />
                </form>
            </FormProvider>

            <SemanticSearchDisclaimer />
        </div>
    );
}

const formContainer = css({
    width: "100%"
});

const formStyle = css({
    width: "100%"
});

const textArea = css({
    width: "100%",
    transition: "min-height 0.3s ease-in-out",

    _placeholder: {
        fontSize: 15.75,
        color: "var(--colors-gray-700)"
    }
});

const textAreaWrapper = css({
    p: 1.5,
    borderRadius: 2
});

const textAreaWrapperInner = css({
    flexDirection: "row",
    alignItems: "center"
});

const buttonWrap = css({
    display: "flex",
    height: "100%",
    alignItems: "flex-end"
});

const submitButton = css({
    width: "4.4rem",
    height: "4.4rem",
    minWidth: "unset",
    borderRadius: 1
});
import {useEffect, useRef} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {TextareaField} from "@pg-design/rhf-components-module";
import {useUserDevice} from "@pg-mono/user-device";

import {hitAiAssistantChat} from "../../tracking/semantic_search_gtm_events";
import {SemanticSearchFormValues} from "../../types/SemanticSearchFormValues";
import {SemanticSearchDisclaimer} from "./SemanticSearchDisclaimer";

const semanticSearchFormSchema = Yup.object().shape({
    userQuery: Yup.string().required("Prosimy wpisać zapytanie")
});

interface IProps {
    handleSubmit: (data: SemanticSearchFormValues) => void;
    disabled: boolean;
    hasConversation: boolean;
    hasStickySidebar: boolean;
}

export function SemanticSearchQueryForm(props: IProps) {
    const {handleSubmit, disabled, hasConversation, hasStickySidebar} = props;

    const {isMobile} = useUserDevice();

    const formProps = useForm<SemanticSearchFormValues>({
        defaultValues: {
            userQuery: ""
        },
        resolver: yupResolver(semanticSearchFormSchema)
    });
    const userQuery = useWatch({control: formProps.control, name: "userQuery"});
    const wasFilledRef = useRef(false);

    useEffect(() => {
        const isFilled = userQuery.length > 0;

        if (isFilled && !wasFilledRef.current) {
            hitAiAssistantChat("fill");
        }

        wasFilledRef.current = isFilled;
    }, [userQuery]);

    const onSubmit = (data: {userQuery: string}) => {
        if (disabled || !data.userQuery.trim()) return;

        hitAiAssistantChat("submit");
        handleSubmit(data);
        formProps.reset();
    };

    const numberOfRows = hasConversation ? 1 : isMobile || hasStickySidebar ? 3 : 2;
    const placeholder = hasConversation
        ? "O co chcesz zapytać?"
        : hasStickySidebar
          ? "Szukam mieszkania 2 pokojowego, do 60 m2, z balkonem, na osiedlu z placem zabaw."
          : "Szukam mieszkania 2 pokojowego, do 60 m2, z balkonem, na Żoliborzu, na osiedlu z placem zabaw.";

    return (
        <div className={formContainer}>
            <FormProvider {...formProps}>
                <form onSubmit={formProps.handleSubmit(onSubmit)} className={formStyle}>
                    <TextareaField
                        name="userQuery"
                        rows={numberOfRows}
                        hideErrorMessage
                        onClick={() => hitAiAssistantChat("click")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                formProps.handleSubmit(onSubmit)();
                            }
                        }}
                        placeholder={placeholder}
                        inputClassName={textArea}
                        inputWrapperClassName={textAreaWrapper}
                        inputWrapperInnerClassName={textAreaWrapperInner}
                        inputContentSlot={
                            <div className={buttonWrap}>
                                <Button variant="filled_primary" type="submit" className={submitButton} disabled={disabled}>
                                    <ChevronRightIcon size="2.4" wrapperSize="4.4" wrapperColor="transparent" wrapperType="square" />
                                </Button>
                            </div>
                        }
                    />
                </form>
            </FormProvider>

            <SemanticSearchDisclaimer />
        </div>
    );
}

const formContainer = css({
    width: "100%"
});

const formStyle = css({
    width: "100%"
});

const textArea = css({
    width: "100%",
    transition: "min-height 0.3s ease-in-out",

    _placeholder: {
        fontSize: 15.75,
        color: "var(--colors-gray-700)"
    }
});

const textAreaWrapper = css({
    p: 1.5,
    borderRadius: 2
});

const textAreaWrapperInner = css({
    flexDirection: "row",
    alignItems: "center"
});

const buttonWrap = css({
    display: "flex",
    height: "100%",
    alignItems: "flex-end"
});

const submitButton = css({
    width: "4.4rem",
    height: "4.4rem",
    minWidth: "unset",
    borderRadius: 1
});
